<template>
  <v-card
    tile
    flat
    class="grey lighten-3 ma-3"
    :height="height"
    @click="$emit('itemClick')"
    outlined
  >
    <div class="blue" style="position:relative">
      <div class="white px-2 d-flex flex-column align-center">
        <ShaftImage :shaft="shaft" class="shaft-image" v-if="!loading" />
      </div>
      <v-icon
        class="ml-1 text-end shaft-ordered-icon"
        v-if="shaft.ordered"
        small
      >
        mdi-cart-check
      </v-icon>
    </div>
    <v-card-title>
      <span class="shaft-title">{{ titleEllipsis }}</span>
    </v-card-title>
    <v-card-subtitle v-if="shaft.site_id" class="pt-1">
      {{ siteNameEllipsis }}
    </v-card-subtitle>
  </v-card>
</template>

<script>
import ShaftImage from '@/components/ShaftImage.vue';

export default {
  name: 'ShaftGridCard',
  components: { ShaftImage },
  props: ['shaft', 'height', 'loading'],
  computed: {
    titleEllipsis() {
      if (this.shaft.title && this.shaft.title.length > 20)
        return this.shaft.title.substring(0, 20) + '...';
      return this.shaft.title;
    },
    siteNameEllipsis() {
      if (this.shaft?.site_id?.name && this.shaft.site_id.name.length > 20)
        return this.shaft.site_id.name.substring(0, 20) + '...';
      return this.shaft?.site_id?.name;
    },
  },
};
</script>

<style scoped>
.shaft-image {
  max-width: 130px;
  height: 125px;
}

.shaft-title {
  font-size: 1.1rem;
  line-height: 1.1rem;
}

.shaft-ordered-icon {
  position: absolute !important;
  right: 5px;
  bottom: 5px;
}
</style>
